// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"136":"events","681":"users","713":"risk-level","966":"dashboard","986":"regions"}[chunkId] + "." + {"136":"94407dd8","681":"c29a705d","713":"3cc42ef9","966":"e55c9c65","986":"f9ecd3e1"}[chunkId] + ".css";
};